const initialState = {
  passportData: null,
};

export const passportReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case "SET_PASSPORT_DATA":
      return { ...state, passportData: action.payload };
    case "SET_ADDRESS_DATA":
      return { ...state, addressData: action.payload };
    case "SET_WORK_DATA":
      return { ...state, workData: action.payload };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};
